import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/not-found.js")